import { Screen } from '~/screens/StressAssessments/schedule';

export const StressAssessmentsSchedule: React.FC = () => {
  return <Screen />;
};
